import NoiseOverlay from '../NoiseOverlay';

/**
 * ContentImageSection Component
 * Универсальный компонент: HTML контент слева, изображение справа
 * @param {ReactNode} children - HTML контент слева
 * @param {string} image - URL изображения справа (дефолт: /src/images/bg.jpg)
 * @param {string} imageAlt - Alt текст для изображения
 * @param {string} className - Дополнительные CSS классы
 */
export default function ContentImageSection({
  children,
  image = '/images/bg.jpg',
  imageAlt = '',
  className = '',
}) {
  return (
    <div className={`py-12 ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div>{children}</div>
        <div className="relative h-96 md:h-full">
          <NoiseOverlay>
            <img 
              src={image} 
              alt={imageAlt} 
              className="w-full h-full object-cover rounded-lg" 
            />
          </NoiseOverlay>
        </div>
      </div>
    </div>
  );
}
